import React from "react";
import logo from "assests/logo-footer.png";
const LogoFooter = () => {
  return (
    <div>
      <img className="w-1/2 lg:w-3/4 " src={logo} alt="" />
    </div>
  );
};

export default LogoFooter;
